export type AppRouteId =
  | "play"
  | "match"
  | "manage_cards"
  | "manage_heroes"
  | "manage_decks"
  | "stats"
  | "account"
  | "admin"
  | "not_found"

export type AppNavGroupId = "play" | "manage" | "stats" | "account" | "admin"
export type MainNavGroupId = Exclude<AppNavGroupId, "account">

export type AppNavGroup = {
  id: MainNavGroupId
  path: string
}

export type AppResolvedRoute = {
  id: AppRouteId
  navGroup: AppNavGroupId
  pathname: string
}

export const APP_NAV_GROUPS: readonly AppNavGroup[] = [
  { id: "play", path: "/play" },
  { id: "manage", path: "/manage/cards" },
  { id: "stats", path: "/stats" },
  { id: "admin", path: "/admin" },
]

function stripSearchAndHash(pathname: string): string {
  return pathname.split(/[?#]/u, 1)[0] ?? "/"
}

export function normalizeAppPath(pathname: string): string {
  const stripped = stripSearchAndHash(pathname.trim())
  if (!stripped || stripped === "/") return "/"
  const normalized = stripped.replace(/\/+$/u, "")
  return normalized.startsWith("/") ? normalized : `/${normalized}`
}

export function resolveAppRoute(pathname: string): AppResolvedRoute {
  const p = normalizeAppPath(pathname)

  if (p === "/" || p === "/play") {
    return { id: "play", navGroup: "play", pathname: p }
  }
  if (p === "/play/match" || p.startsWith("/play/match/")) {
    return { id: "match", navGroup: "play", pathname: p }
  }
  if (p.startsWith("/play/")) {
    return { id: "play", navGroup: "play", pathname: p }
  }
  if (p === "/manage/decks" || p.startsWith("/manage/decks/")) {
    return { id: "manage_decks", navGroup: "manage", pathname: p }
  }
  if (p === "/manage/heroes" || p.startsWith("/manage/heroes/")) {
    return { id: "manage_heroes", navGroup: "manage", pathname: p }
  }
  if (
    p === "/manage" ||
    p === "/manage/cards" ||
    p.startsWith("/manage/cards/")
  ) {
    return { id: "manage_cards", navGroup: "manage", pathname: p }
  }
  if (p === "/stats" || p.startsWith("/stats/")) {
    return { id: "stats", navGroup: "stats", pathname: p }
  }
  if (p === "/account" || p.startsWith("/account/")) {
    return { id: "account", navGroup: "account", pathname: p }
  }
  if (p === "/admin" || p.startsWith("/admin/")) {
    return { id: "admin", navGroup: "admin", pathname: p }
  }

  return { id: "not_found", navGroup: "play", pathname: p }
}
